// src/services/seeker-discovery-service.js
// Client-side service for the AI Seeker Discovery feature.
// Calls the seekerDiscovery Cloud Function (public HTTP endpoint).

const SEEKER_DISCOVERY_URL =
  "https://us-west1-divine-frameworks-6cb16.cloudfunctions.net/seekerDiscovery";

/**
 * Ask the AI to find practitioners matching a natural language query.
 *
 * @param {string} query — e.g. "I'm going through a breakup and need guidance"
 * @returns {Promise<{ recommendations: object[], seekerSummary: string, totalMatched: number }>}
 */
export async function discoverPractitioners(query) {
  const res = await fetch(SEEKER_DISCOVERY_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query: query.trim() }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    if (res.status === 429) {
      throw new Error("rate_limited");
    }
    throw new Error(body.error || `Request failed (${res.status})`);
  }

  return res.json();
}

/**
 * Refine a previous set of AI results with a follow-up message.
 *
 * @param {string} originalQuery
 * @param {object} previousResult — the full result object from discoverPractitioners()
 * @param {string} refinement     — e.g. "actually I prefer someone virtual, under $100"
 * @returns {Promise<{ recommendations: object[], seekerSummary: string, totalMatched: number }>}
 */
export async function refinePractitioners(originalQuery, previousResult, refinement) {
  const res = await fetch(SEEKER_DISCOVERY_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query: originalQuery,
      refine: refinement.trim(),
      previousResult,
    }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    if (res.status === 429) {
      throw new Error("rate_limited");
    }
    throw new Error(body.error || `Request failed (${res.status})`);
  }

  return res.json();
}
